var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 173,
    viewBox: "0 0 208 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10488",
    "data-name": "Rectangle 10488",
    width: 208,
    height: 173,
    transform: "translate(652 2965)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10478",
    "data-name": "Rectangle 10478",
    width: 140,
    height: 140,
    transform: "translate(4268 2108)",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87725",
    "data-name": "Mask Group 87725",
    transform: "translate(-652 -2965)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9898",
    "data-name": "Path 9898",
    d: "M2385.752-2212.486c30.615-27.545,79.059-32.622,116.419-15.048s59.408,50.559,52.158,81.452-35.779,41.791-80.906,47.522-77.427.338-93.712-18.794S2355.137-2184.941,2385.752-2212.486Z",
    transform: "translate(-1949.996 4902.267) rotate(7)",
    fill: "#e1ffde"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87721",
    "data-name": "Mask Group 87721",
    transform: "translate(-3582 877)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-cash-5679064",
    transform: "translate(4277.582 2136.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9899",
    "data-name": "Path 9899",
    d: "M67.036,49.85a5.214,5.214,0,0,0,5.209,5.209H76.6a7.866,7.866,0,0,1,3.545,14.9v3.893a1.343,1.343,0,0,1-2.686,0V70.74c-.269.027-.564.081-.833.081h-4.35a7.9,7.9,0,0,1-.833-.081v3.115a1.343,1.343,0,0,1-2.686,0V69.962a7.842,7.842,0,0,1-4.35-7.008,1.343,1.343,0,0,1,2.686,0A5.214,5.214,0,0,0,72.3,68.163h4.35a5.209,5.209,0,0,0,0-10.418H72.3a7.866,7.866,0,0,1-3.545-14.9V38.949a1.343,1.343,0,1,1,2.686,0v3.115c.269-.027.564-.081.833-.081h4.35a7.892,7.892,0,0,1,.833.081V38.949a1.343,1.343,0,1,1,2.686,0v3.893a7.842,7.842,0,0,1,4.35,7.008,1.343,1.343,0,0,1-2.686,0A5.214,5.214,0,0,0,76.6,44.64h-4.35a5.214,5.214,0,0,0-5.209,5.209Zm78.543,2.524v56.39a1.33,1.33,0,0,1-1.343,1.343H47.568a1.33,1.33,0,0,1-1.343-1.343V96.68h-9.4a1.33,1.33,0,0,1-1.343-1.343v-9.4h-9.4A1.33,1.33,0,0,1,24.744,84.6V28.206a1.33,1.33,0,0,1,1.343-1.343h96.669a1.33,1.33,0,0,1,1.343,1.343v9.4h9.4a1.33,1.33,0,0,1,1.343,1.343V51.031h9.4a1.33,1.33,0,0,1,1.343,1.343Zm-24.167,14.85V45.607a17.438,17.438,0,0,1-16.031-16.031H43.46A17.438,17.438,0,0,1,27.43,45.606V67.222A17.438,17.438,0,0,1,43.46,83.253h61.895a17.438,17.438,0,0,1,16.031-16.031ZM108.04,83.254h13.373V69.881A14.813,14.813,0,0,0,108.04,83.254Zm0-53.7a14.813,14.813,0,0,0,13.373,13.373V29.549ZM27.43,42.921A14.813,14.813,0,0,0,40.8,29.548H27.43V42.922Zm0,40.331H40.8A14.813,14.813,0,0,0,27.43,69.88ZM38.171,93.994h93.983v-53.7H124.1V84.6a1.33,1.33,0,0,1-1.343,1.343H38.17v8.056ZM142.9,53.715h-8.056V95.336a1.33,1.33,0,0,1-1.343,1.343H48.911V107.42h93.983Z",
    transform: "translate(-24.744 -26.863)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.df068b2b715da1ccd41af3a40bcce0e2.svg";
export { ForwardRef as ReactComponent };